/// <amd-module name="Feed/Legacy/Protocols/PyPi/PyPiConstants" />
import { PerfScenarios } from "Feed/Common/Constants/Constants";

export const PyPiKey = "PyPi";

/**
 * Perfomance scenario constants.
 */
export class PyPiPerfScenarios extends PerfScenarios {
    public static readonly DeletePackage = "Packaging.Package.PyPi.RemovePackage";
}

export class PyPiCiConstants {
    public static readonly ProtocolName = "PyPi";
    public static readonly PyPiConnectToFeedPanel = "PyPiConnectToFeedPanel";
}

export class IndexIds {
    public static readonly PyPiSimplePackageNameLocationId = "93377A2C-F5FB-48B9-A8DC-7781441CABF1"; // PyPiSimplePackageNameLocationId
    public static readonly PyPiUploadLocationId = "C7A75C1B-08AC-4B11-B468-6C7EF835C85E"; // PyPiPackagesLocationId
}

export class PyPiEndpointKeys {
    public static readonly PyPiConnectionEndpointKey = "pypiConnect";
    public static readonly PyPiPackagesEndpointKey = "pypi";
}
